import { getItem } from "../Utils/localStorageUtils";
import axios from "axios";

const baseURL = `${process.env.REACT_APP_Baseurl}`;

const siteThemeActionBackEnd = () => async (dispatch) => {
    dispatch({ type: "GET_SITE_REQUEST", payload: {}, loading: true });
    try {
        const config = {
            method: 'GET',
            url: `${baseURL}/admin/Site-ThemeSetting/index`,
            params: {},
            data: {},
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + getItem("access_token"),
            },
        };
        const response = await axios(config);
        const result = response?.data;
        dispatch({ type: "GET_SITE_THEME", payload: result, loading: false });

    } catch (error) {
        const response = error?.response?.data?.message;
        dispatch({ type: "GET_SITE_THEME_FAILED", payload: response });
    }
};

const languageCodeActionBackEnd = () => async (dispatch) => {
    try {
        const response = {
            method: 'GET',
            url: `${baseURL}/admin/User-Translate-Language`,
            params: {},
            data: {},
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + getItem("access_token"),
            },
        };
        const result = await axios(response);
        // console.log("RESULT:", result);
        const ListRes = result?.data?.Language_Code || 'en';
        dispatch({type: "GET_LANGUAGE_CODE", payload: ListRes});
    } catch (error) {
        const response = error?.response?.data?.message;
        dispatch({type: "GET_LANGUAGE_CODE_FAILED", payload: response});
    }
}

export { siteThemeActionBackEnd, languageCodeActionBackEnd };
